import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import BreadcrumbPage from "@Components/Home/BreadcrumbPage/BreadcrumbPage";
import OfficeDetailsBanner from "@Components/OfficeDetails/OfficeDetailsBanner/OfficeDetailsBanner";
import OfficeDescription from "@Components/OfficeDetails/OfficeDescription/OfficeDescription";
import FeaturedProperties from "@Components/PropertyDetails/FeaturedProperties/FeaturedProperties";
import { useQuery } from '@apollo/client';
import HomeGetStart from "@Components/Home/HomeGetStart/HomeGetStart";
import gql from "graphql-tag"
import { Container, Row, Col } from 'react-bootstrap';
import AgentsTeam from "@Components/StaticPage/AgentsTeam/AgentsTeam";
import { Helmet } from "react-helmet";
import SEO from "@Components/SEO/seo";
import logoBlack from "../../images/logo-t.svg";

const OfficeDetails = (props) => {
    const GET_Offices_DETAILS = gql`
  query GetOffices($URL: String!){	
    offices(where:{URL: $URL}){
      id
      imagetransforms
      ggfx_results {
        id
        content_type
        transforms
        src_import_url
        src_cftle
        field
      }
        Office_Name
        Office_Email
        Office_Address
        Lettings_Phone
        Sales_Phone
        Lettings_Phone
        Sales_Phone
        Add_Office_Hours {
            Day
            Time
        }
        Choose_Person {
          id
          imagetransforms
          ggfx_results {
            id
            content_type
            transforms
            src_import_url
            src_cftle
            field
          }
            Name
            Designation
            Image {
              url
              alternativeText
            }
            Video_Url
          }
          Team_Content
          Teams {
            URL
            id
            imagetransforms
            ggfx_results {
              id
              content_type
              transforms
              src_import_url
              src_cftle
              field
            }
            Name
            Designation
            Image {
              url
              alternativeText
            }
            Video_Url
          }
        Content
        Latitude
        Local_Life_Content
        Local_Life_Title
        Local_Life_Video_Url
        Longitude
        Publish
        Local_Life_Image {
            alternativeText
            url
        }
        Office_Image {
            url
            alternativeText
        }
    }      
  }
`;
  const { loading, error, data } = useQuery(GET_Offices_DETAILS, {
    variables: { URL: props.slug }
  });

  // console.log(data)

  // if (loading) return (
  //   <section className={"loader-wrapper"}>
  //     <div id="loader-wrapper">
  //       <div id="loader" class="new-loader">
  //         <div className="new-loader-anime"></div>
  //         <img className="logo-white" src={logoBlack} className="loader-logo" alt="logo" />
  //       </div>
  //       <div class="loader-section section-left"></div>
  //       <div class="loader-section section-right"></div>
  //     </div>
  //   </section>
  // );

  if (loading) return (
    <div className="static-news gql-loading-screen">
      <Container>
        <div className="gql-loading">
        <img className="logo-white loader-logo" src={logoBlack} alt="logo" />
          </div>
      </Container>
    </div>
  );

  return (
        <React.Fragment>
            <SEO title={data?.offices[0] ? 'Estate Agents in '+data?.offices[0]?.Office_Name : ''} description={data?.offices[0] ? 'Contact estate agents in '+data?.offices[0]?.Office_Name+' and find you dream home, our property experts help you find the right property for you.' : ''} />
            <div className="header-logo-black"><Header/></div>
            {/* {JSON.stringify(data?.offices[0])} */}
            <OfficeDetailsBanner data={data?.offices[0]}/>
            <OfficeDescription data={data?.offices[0]}/>
            <AgentsTeam office={data?.offices[0]?.Office_Name} content={data?.offices[0]?.Team_Content} teams={data?.offices[0]?.Teams} />
            <HomeGetStart nobanner={true} />
            <FeaturedProperties area={data?.offices[0]?.Office_Name}/>
            <div className="breadcrumb-other-page"><BreadcrumbPage Page={data?.offices[0]?.Office_Name} class="static" alias={'contact'} type="details-page"/></div>
            <Footer popularSearch={'Office'}/>
        </React.Fragment>
    )
}

export default OfficeDetails